<template>
  <vs-row>
    <vs-col :vs-w="showFiltersTransition ? 9 : 12" class="p-2">
      <vx-card v-if="members"
               v-show="filterValues">
        <div class="flex flex-end">
          <feather-icon class="filter-hover-button" @click="onShowFilters()" icon="FilterIcon" :svgClasses="'h-8 w-8 mb-1 mr-3 stroke-current text-primary'"/>
        </div>
        <sm-hateoas-table
          ref="membersTable"
          @selected="handleSelected"
          :paged-resources="members"
          :relation="'members'"
          :search="true"
          :pagination="true"
          :filters="filterValues">
          <template slot="thead">
          <vs-th sort-key="createdDate">
            {{ $t('view_members.member_since') }}
          </vs-th>
          <vs-th sort-key="firstName">
            {{ $t('view_members.name') }}
          </vs-th>
          <vs-th width="20%">
            {{ $t('view_members.program') }}
          </vs-th>
          <vs-th v-if="hasPhq9Permission">
            {{ $t('view_members.checkup_date') }}
          </vs-th>
          <vs-th v-else-if="isCaseManagerTeamOn">
            {{ hqTeamLabel }}
          </vs-th>
          <vs-th v-if="hasPhq9Permission">
            {{ $t('view_members.phq9_self_harm') }}
          </vs-th>
          <vs-th v-else>
            {{ $t('view_members.last_activity') }}
          </vs-th>
          <vs-th>
          </vs-th>
          </template>

          <template slot-scope="{data}">
          <vs-tr :data="tr" :key="data[indextr].id" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].memberSince">
              {{ data[indextr].memberSince | moment('MMM D, YYYY') }}
            </vs-td>

            <vs-td :data="data[indextr].firstName">
              <div>
            <span>{{data[indextr].firstName}} {{data[indextr].lastName}}</span>
              </div>
              <div>
                <span>{{data[indextr].email}}</span>
              </div>
              <div>
                <span>{{ userIdLabel}}: {{data[indextr].claimNumber}}</span>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].program">
              <span v-if="data[indextr].$hasEmbedded('access-code')">{{ $t('filters.REFERRAL_PROGRAMS.values.' + data[indextr].$getEmbedded('access-code').program) }}</span>
              <span v-else>{{ $t('filters.REFERRAL_PROGRAMS.values.none')}}</span>
            </vs-td>
            <vs-td v-if="hasPhq9Permission" :data="data[indextr].phq9SelfHarmAnswer.checkupDate">
                {{ formatDateTime(data[indextr].phq9SelfHarmAnswer.checkupDate) }}
            </vs-td>
            <vs-td v-else-if="isCaseManagerTeamOn" :data="data[indextr].hqTeamGroupName">
              {{data[indextr].hqTeamGroupName ? data[indextr].hqTeamGroupName : '--'}}
            </vs-td>
            <vs-td v-if="hasPhq9Permission" :data="data[indextr].phq9SelfHarmAnswer">
                <div class="content-center">
                  <div class="custom-circle-dot" :style="applyColorCode(data[indextr].phq9SelfHarmAnswer.choiceNumber)"></div>
                  {{ data[indextr].phq9SelfHarmAnswer.choiceText }}
                </div>
            </vs-td>
            <vs-td v-else-if="data[indextr].lastActivity" :data="data[indextr].lastActivity">
              {{data[indextr].lastActivity | moment('MMM D, YYYY')}}
            </vs-td>
            <vs-td v-else>
              --
            </vs-td>

            <vs-td style="white-space: nowrap;">
              <vs-row>
                <vs-col vs-w="9">
                  <vs-row>
                    <vs-col>
                      <vs-button
                        v-if="data[indextr].$hasLink('member')"
                        @click="onDischarge(data[indextr])"
                        type="filled"
                        color="primary"
                        class="mr-3">{{ $t('dashboard.block.members.buttons.discharge') }}
                      </vs-button>
                      <vs-button
                        v-if="data[indextr].$hasLink('member')"
                        @click="onView(data[indextr])"
                        type="filled"
                        color="secondary"
                        class="">{{ $t('view_members.buttons.view_member') }}
                      </vs-button>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-td>

          </vs-tr>
          </template>
        </sm-hateoas-table>
      </vx-card>
    </vs-col>
     <vs-col :vs-w="3" class="p-2">
      <sm-hateoas-filters ref="onFilter" v-if="filters" v-show="showFiltersTransition" :filter-resource="filterResource" @update-transition="onUpdateFilterTransition" :filters="filters" @filters-change="onFilterChange"></sm-hateoas-filters>
    </vs-col>
  </vs-row>
</template>

<script>
import SmHateoasTable from '@/components/starling/sm-hateoas-table/sm-hateoas-table';
import {ResourceImpl} from 'hal-client';
import SmHateoasFilters from '@/components/starling/sm-hateoas-filters/sm-hateoas-filters';
import moment from 'moment';

export default {
  name: 'view-members',
  now: new Date(),
  components: {
    SmHateoasFilters,
    SmHateoasTable
  },
  props: {
    membersResource: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      members: this.membersResource,
      filters: null,
      filterValues: null,
      showFiltersTransition: false,
      refreshKey: 0,
      intervalId: null,
      userIdLabel : null,
      filterResource: null,
      isCaseManagerTeamOn: null,
      hqTeamLabel: null,
      hasPhq9Permission: null
    };
  },
  mounted () {
    this.members.$request().$get('user-id-label', null, {locale:'en'}).then((res) => {
      this.userIdLabel = res.state().label;
      if (!this.userIdLabel) {
        this.userIdLabel = this.$t('view_member.block.report.fields.user_id');
      }
    });
    this.members.$request().$get('hq-team-label', null, {locale:'en'}).then((res) => {
      this.isCaseManagerTeamOn = res.state().enabled;
      this.hqTeamLabel = res.state().label;
      if (!this.hqTeamLabel) {
        this.hqTeamLabel = this.$t('view_members.team');
      }
    });
    if (this.members.$hasLink('filters')) {
      this.members.$request().$get('filters').then(res => {
        this.filters = res.$getEmbedded('filters');
        this.filterResource = res;
      });
    }
    const metadataLink = this.members.$link('metadata-flag').href;
    const url = new URL(metadataLink);
    const params = new URLSearchParams(url.search);
    this.hasPhq9Permission = params.get('hasPhq9Permission') === 'true';
  },
  methods: {
    handleSelected () {
    },
    onCheckTime (lastSent) {
      return !moment().isAfter(moment(lastSent).add(5, 'm'));
    },
    onFilterChange (filters) {
      this.filterValues = filters;
    },
    refreshTable () {
      this.$refs.membersTable.refresh();
    },
    onUpdateFilterTransition () {
      this.showFiltersTransition = !this.showFiltersTransition;
    },
    onShowFilters () {
      this.$refs.onFilter.onShowFilters();
    },
    onView (member) {
      this.$router.push({
        name: 'app-view-member',
        params: {id: member.id}
      });
    },
    onDischarge (member) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: this.$t('dashboard.block.members.confirmations.discharge.title'),
        text: this.$t('dashboard.block.members.confirmations.discharge.text'),
        accept: () => {
          member.$request().$post('discharge').then((res) => {
            this.members = res;  // Reassign with updated data
            this.$vs.notify({
              title: this.$t('dashboard.block.members.confirmations.notifications.sent.title'),
              text: this.$t('dashboard.block.members.confirmations.notifications.sent.text'),
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            });
          }, () => {
            this.$vs.notify({
              title: this.$t('dashboard.block.members.confirmations.notifications.not_sent.title'),
              text: this.$t('dashboard.block.members.confirmations.notifications.not_sent.text'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
        }
      });
    },
    formatDateTime (dateTime) {
      if (!dateTime) {
        return;
      }
      if (!moment(dateTime).isValid()) {
        return;
      }
      const now = moment();
      const dateMoment = moment(dateTime);
      const duration = moment.duration(now.diff(dateMoment));
      const hours = duration.asHours();
      const days = duration.asDays();
      const weeks = duration.asWeeks();

      if (hours < 1) {
        return '<1 hour ago';
      }
      if (hours < 24) {
        return `${Math.floor(hours)} hours ago`;
      }
      if (days < 7) {
        return `${Math.floor(days)} days ago`;
      }
      if (weeks <= 8) {
        return `${Math.floor(weeks)} weeks ago`;
      }
      return dateMoment.format('MMMM D, YYYY');
    },
    applyColorCode (value) {
      switch (value) {
      case 0:
        return { backgroundColor: '#5EEC65' };
      case 1:
        return { backgroundColor: '#F7A300' };
      case 2:
        return { backgroundColor: '#DF2800' };
      case 3:
        return { backgroundColor: '#A71F1F' };
      default:
        return { backgroundColor: '#DCDCDC' };
      }
    }
  }
};
</script>

<style scoped>
.content-center {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  flex-grow: 0;
}
.custom-circle-dot {
  height: 1.5em;
  width: 1.5em;
  border-radius: 50%;
  flex-shrink: 0;
  flex-grow: 0;
  aspect-ratio: 1 / 1;
  margin-right: 8px;
}

</style>
